if ($("header#header").length) {

    $(".search-input").attr("placeholder", "Hledat produkty");
    $(".responsive-tools").prepend($(".top-navigation-tools .dropdown").clone());
    $('.navigation-buttons a[data-target="cart"]').clone().appendTo(".responsive-tools");
    $(".header-top").append($(".top-navigation-bar .responsive-tools"));

    $('#customerLogin label[for="loginWidgetEmail"] span').text('Uživatelské jméno nebo e-mail');

    $('#customerLogin input#loginWidgetEmail').attr('placeholder', 'E-mailová adresa (např. jan@novak.cz)');
    $('#customerLogin input#loginWidgetPassword').attr('placeholder', 'Heslo');

    $('<span class="close"></span>').appendTo(
        ".login-widget .popup-widget-inner",
    );


    $(".project-phone").after(INFOLINKA);

    $(document).ready(function () {
        $('.search-form button').text(translation('hledat'));
    });


    $(document).on(
        "click",
        ".login-widget .popup-widget-inner .close",
        function () {
            $("body").removeClass("user-action-visible login-window-visible");
        },
    );

    $(document).ready(function () {
        let target = "cart";
        let timeout;
        const $cartHoverArea = $('a[data-target="cart"]');
        $cartHoverArea.on("mouseenter", function () {
            var show =
                target === "cart" && !$('a[data-target="cart"]').hasClass("full")
                    ? false
                    : true;
            shoptet.popups.showPopupWindow(target, show);
        });
    });



    document.addEventListener('dkLabProductComparerLoaded', function () {
        $('header#header .responsive-tools').append('<div id="dkLabComparerHeaderWrappper"><span class="dkLabComparerHeaderIconBtn " id="dkLabComparerHeaderIconBtn"><em></em></span></div>');
    });
    document.addEventListener('dkLabProductComparerProductsChanged', function () {
        $('header#header .responsive-tools #dkLabComparerHeaderWrappper em').text($('.navigation-buttons #dkLabComparerHeaderWrappper em').text());
    });
    document.addEventListener('dkLabProductComparerHeaderChanged', function () {
        $('header#header .responsive-tools #dkLabComparerHeaderWrappper em').text($('.navigation-buttons #dkLabComparerHeaderWrappper em').text());
    });


}

$('html').on('click', 'header#header .responsive-tools #dkLabComparerHeaderWrappper', function () {
    $('.navigation-buttons #dkLabComparerHeaderWrappper span').trigger('click')
})




if ($("body:not(.ordering-process)").length) {
    $('#header').after(`<div class="logo">
        <img src="/user/documents/upload/sablona/logo_red.svg" alt="Miele Centrum Vlasek">
        </div>`);
}